export const APP_VERSION = 'v1.3.34'
